import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, Output, ViewChild } from '@angular/core';

/**
 * "How this works" (P6:1299-1311, `.cx-dlg`): a native `<dialog>` so focus trapping, Esc and the top layer come from the
 * browser. Open is driven by the `Open` input; every way out (Esc, backdrop click, "Got it") emits `Closed` so the host's flag
 * follows the dialog.
 */
@Component({
    standalone: false,
    selector: 'ra-cx-about-dialog',
    templateUrl: './cx-about-dialog.component.html',
    styleUrl: './cx-about-dialog.component.scss',
})
export class CxAboutDialogComponent implements AfterViewInit, OnChanges {
    @Input() Open = false;
    @Output() readonly Closed = new EventEmitter<void>();
    @ViewChild('dlg') private dlg?: ElementRef<HTMLDialogElement>;

    ngAfterViewInit(): void {
        const el = this.dlg?.nativeElement;
        // 'cancel' is Esc: let the native close happen, then tell the host.
        el?.addEventListener('cancel', () => this.Closed.emit());
        this.Sync();
    }

    ngOnChanges(): void {
        this.Sync();
    }

    Close(): void {
        this.dlg?.nativeElement.close();
        this.Closed.emit();
    }

    /** A click on the `<dialog>` element itself (not its panel) is a backdrop click. */
    OnDialogClick(event: MouseEvent): void {
        if (event.target === this.dlg?.nativeElement) this.Close();
    }

    private Sync(): void {
        const el = this.dlg?.nativeElement;
        if (!el) return;
        if (this.Open && !el.open && typeof el.showModal === 'function') el.showModal();
        if (!this.Open && el.open) el.close();
    }
}
